import {styled} from '@linaria/react';
import React from 'react';
import {
  BaseProductTile,
  BaseProductTileProps,
} from '../BaseProductTile/BaseProductTile';
import {
  AddToBasketCtaContainer,
  ProductDetailsWrapper,
} from '../BaseProductTile/ProductDetails';
import {ProductTileWrapper} from '../BaseProductTile/ProductTileWrapper';
import {Wrapper as ProductTileImageWrapper} from '../ProductTileImage/ProductTileImage';

export const FullHeightProductTileBase = (props: BaseProductTileProps) => {
  return (
    <FullHeightTileWrapper>
      <BaseProductTile {...props} />
    </FullHeightTileWrapper>
  );
};

const FullHeightTileWrapper = styled.div`
  height: 100%;

  > * {
    height: 100%;
  }

  ${ProductTileWrapper} {
    height: 100%;
  }

  ${ProductTileImageWrapper} {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  ${ProductDetailsWrapper} {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  /* Move price hints (OriginalPrice, LPL30D, Sponsored) after color bubbles */
  ${ProductDetailsWrapper} > [data-original-price] {
    order: 1;
  }

  ${AddToBasketCtaContainer} {
    margin-top: auto;
    order: 2;
  }
`;
